import { Injectable, computed, inject, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ApiService } from '../api.service';
import { Assessment } from '../models';

@Injectable({ providedIn: 'root' })
export class AssessmentDomainService {
  private readonly api = inject(ApiService);

  private readonly allAssessmentsSignal = signal<Assessment[] | null>(null);
  readonly allAssessments = computed(() => this.allAssessmentsSignal());

  private readonly projectAssessmentsSignal = signal<Assessment[] | null>(null);
  readonly projectAssessments = computed(() => this.projectAssessmentsSignal());

  loadAssessments(): Observable<Assessment[]> {
    return this.api
      .getAssessments()
      .pipe(tap((assessments) => this.allAssessmentsSignal.set(assessments)));
  }

  loadProjectAssessments(projectId: string): Observable<Assessment[]> {
    return this.api
      .getProjectAssessments(projectId)
      .pipe(tap((assessments) => this.projectAssessmentsSignal.set(assessments)));
  }
}
